<script>
import {
  BaseAffiliateLinkElementMixin,
} from "%/dynamic-component-editor/standard-components/base-affiliate-link-card/base-affiliate-link-element-mixin";
import BaseButtonElement
  from "%/dynamic-component-editor/standard-elements/button-element/BaseButtonElement.vue";
import OpenInNewTab from "%/dynamic-component-editor/options/open-in-new-tab";

export default {
  name: "ProductLinkViewButton",
  elementPanelSettings: {
    displayName: "View",
    elementGroup: "Product",
  },
  extends: BaseButtonElement,
  mixins: [BaseAffiliateLinkElementMixin],
  options: [
    new OpenInNewTab(),
  ],
  methods: {
    handleButtonClick() {
      return this.editMode ? null : this.viewProductLink();
    },
    viewProductLink() {
      if (this.getOptionValue(OpenInNewTab)) {
        window.open(this.entity.affiliateLink, "_blank", "noopener");
        return;
      }
      window.location.href = this.entity.affiliateLink;
    },
  },
};
</script>
